export const localeEn = {
    primary: 'Primary',
    secundary: 'Secundary',
    tertiary: 'Tertiary',
    warning: 'Warning',
    withicon: 'Whit Icon',
    option_one: "Option one",
    option_two: "Option two",
    option_three: "Option three",
    option_four: "Option four",
    option_unique: 'Option unique',
    default_text: 'Default',
    required_message: 'This field is required',
    username_label: 'Username',
    password_label: 'Password',
    subscription_label: 'Subscribe',
    sex_label: "Sex",
    shopping_list_label: "Shopping list",
    submit_label: "Send",
    report_setup: 'Report Setup',
    report_option: 'Report Options',
    close: 'Close',
    clear: 'Clear',
    clear_all: 'Clear All',
    placeholder_text: 'placeholder text',
    title_label: 'Title label',
    assistive_text: 'Assistive text',
    information_fied: 'information about this field',
    required_title_info: 'Required input field using form',
    only_integer_number: 'Only integer numbers allowed',
    decimal_number: 'Decimal numbers allowed',
    select_all: 'Select all',
    on: 'ON',
    off: 'OFF',
    yes: 'YES',
    no: 'NO',
    toggle: 'Toggle',
    tab_one: 'Tab 1',
    tab_two: 'Tab 2',
    tab_three: 'Tab 3',
    option_list: 'Option list',
    cancel: 'Cancel',
    apply: 'Apply',
    upload: 'Upload',
    finish_upload: 'Finish Upload',
    alertstabview_action: "Action",
    alertstabview_summary: "Summary",
    alertstabview_severity: "Severity",
    per_page: 'Per Page',
    all: 'All',
    previous: 'Previous',
    next: 'Next',
    export: 'Export',
    export_csv: "Export CSV",
    export_pdf: "Export PDF",
    delete: 'Delete',
    add: 'Add',
    start: 'Start',
    end: 'End',
    set: 'Set',
    select: 'Select',
    show_all: "Show all",
    collapse_to_ten: "Collapse to ten",
    reminder: "Reminder",
    due_now: "Due Now",
    scheduled: "Scheduled",
    past_due: "Past Due",
    due: "Due",
    due_soon: "Due Soon",
    done: "Done",
    select_subscriber: "Select subscriber",
    add_subscribers: "Add Subscribers",
    fetching_more_list_items: "Fetching more items...",
    filter: "Filter",
    select_date: "Select date",
    maintenance_status: "Maintenance status",
    services: "Services",
    drivers: "Drivers",
    today: "Today",
    yesterday: "Yesterday",
    week: "This week",
    last_week: "Last week",
    this_month: "This month",
    last_month: "Last month",
    quarter: "This quarter",
    last_quarter: "Last quarter",
    tomorrow: "Tomorrow",
    next7days: "Next 7 Days",
    next15days: "Next 15 Days",
    nextMonth: "Next month",
    next30Days: "Next 30 Days",
    next90Days: "Next 90 Days",
    custom: "Custom",
    last7days: "Last 7 Days",
    last30days: "Last 30 Days",
    advanced_filters: "Advanced filters",
    advanced_filter_options: "Advanced Filter Options",
    attachments: 'attachments',
    select_files: 'Select File(s)',
    open_item: 'Open Item',
    lorem_ipsum: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua',
    open_menu: 'Open Menu',
    select_timeframe: "Select a Timeframe",
    same_time_or_after_validation: 'Please complete the ranges of hours by selecting the final time greater than the initial one.',
    change_column_order: "Change column order",
    linked: 'Linked',
    unlinked: 'Unlinked',
    select_temp_url: 'select this image as temporary avatar',
    assigned_to: 'Assigned To:',
    faces_linked_to: 'face(s) are linked to',
    faces_detele: 'Delete this face',
    apply_lang: "Apply",
    draganddrop: 'Drag and drop a file here or click',
    selectAllTags: 'Select all tags',
    inactive: 'Inactive',
    include_inactive_drivers: 'Include Inactive drivers'

}
